import { createReducer } from "typesafe-actions";

import SavedAddress from "@mapmycustomers/shared/types/SavedAddress";

import { sortSavedAddresses } from "@app/util/savedLocations/savedAddressList";

import {
  Actions,
  createSavedAddress,
  deleteSavedAddress,
  fetchSavedAddresses,
  markSavedAddressUsed,
  resetSavedAddresses,
  updateSavedAddress,
} from "./actions";

export interface SavedLocationsState {
  limit?: number;
  savedAddresses?: SavedAddress[]; // undefined until the first load
}

const initialState: SavedLocationsState = {};

// replaceId is the Home/Work row the server deleted in the same transaction
const upsert = (
  savedAddresses: SavedAddress[] | undefined,
  savedAddress: SavedAddress,
  replaceId?: SavedAddress["id"]
) =>
  savedAddresses &&
  sortSavedAddresses([
    ...savedAddresses.filter(({ id }) => id !== savedAddress.id && id !== replaceId),
    savedAddress,
  ]);

const savedLocations = createReducer<SavedLocationsState, Actions>(initialState)
  .handleAction(fetchSavedAddresses.success, (_, { payload }) => payload)
  .handleAction(createSavedAddress.success, (state, { payload }) => ({
    ...state,
    savedAddresses: upsert(state.savedAddresses, payload),
  }))
  .handleAction(updateSavedAddress.success, (state, { payload: { replaceId, savedAddress } }) => ({
    ...state,
    savedAddresses: upsert(state.savedAddresses, savedAddress, replaceId),
  }))
  .handleAction(deleteSavedAddress.success, (state, { payload: id }) => ({
    ...state,
    savedAddresses: state.savedAddresses?.filter((savedAddress) => savedAddress.id !== id),
  }))
  .handleAction(markSavedAddressUsed.success, (state, { payload: { id, lastUsedAt } }) => ({
    ...state,
    savedAddresses:
      state.savedAddresses &&
      sortSavedAddresses(
        state.savedAddresses.map((savedAddress) =>
          savedAddress.id === id ? { ...savedAddress, lastUsedAt } : savedAddress
        )
      ),
  }))
  .handleAction(resetSavedAddresses, () => initialState);

export * from "./selectors";

export type SavedLocationsActions = Actions;

export default savedLocations;
